import { createStore } from 'easy-peasy';
import avatarModel from './models/avatar.model';
import authModel from './models/auth.model';
import pptModel from './models/ppt.model';
import projectsModel from './models/projects.model';
import uiModel from './models/ui.model';
import timelineModel from './models/timeline.model';
import uploadModel from './models/upload.model';

const store = createStore({
  auth: authModel,
  avatar: avatarModel,
  ppt: pptModel,
  projects: projectsModel,
  timeline: timelineModel,
  ui: uiModel,
  upload: uploadModel
});

export default store;
